<template>
  <div class="monitor-list">
    <div class="filter-container">
      <el-form :inline="true" :model="queryParams">
        <el-form-item label="监控数据表名称">
          <el-input v-model="queryParams.target_table" placeholder="请输入表名"></el-input>
        </el-form-item>
        <el-form-item label="监控类型">
          <el-select v-model="queryParams.type" clearable placeholder="请选择">
            <el-option label="缺失值" value="missing"></el-option>
            <el-option label="数据量" value="count"></el-option>
            <el-option label="新增值" value="add"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
          <el-button type="primary" @click="handleCreate">新建监控</el-button>
        </el-form-item>
      </el-form>
    </div>

    <el-table :data="monitorList" border style="width: 100%">
      <el-table-column prop="id" label="监控ID" width="120"></el-table-column>
      <el-table-column prop="target_table" label="监控数据表名称"></el-table-column>
      <el-table-column prop="type" label="监控类型" width="200">
        <template slot-scope="scope">
          {{ typeMap[scope.row.type] }}
        </template>
      </el-table-column>
      <el-table-column prop="trigger_hour" label="监控触发时间" width="200">
        <template slot-scope="scope">
          {{ scope.row.trigger_hour }}:00
        </template>
      </el-table-column>
      <!-- <el-table-column prop="sql" label="监控SQL"></el-table-column> -->
      <el-table-column label="操作" width="200">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.row)">修改</el-button>
          <el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      @current-change="handlePageChange"
      :current-page="currentPage + 1"
      :page-size="10"
      :total="total"
      layout="total, prev, pager, next"
    ></el-pagination>

    <!-- 添加编辑弹窗组件 -->
    <monitor-edit-dialog
      :visible.sync="dialogVisible"
      :monitor-id="currentMonitorId"
      @success="getList"
    />
  </div>
</template>

<script>
import MonitorEditDialog from '@/components/MonitorEditDialog.vue'

export default {
  name: 'MonitorList',
  components: {
    MonitorEditDialog
  },
  data() {
    return {
      queryParams: {
        target_table: '',
        type: '',
        page: 0
      },
      monitorList: [],
      total: 0,
      currentPage: 0,
      typeMap: {
        'missing': '缺失值',
        'count': '数据量',
        'add': '新增值'
      },
      dialogVisible: false,
      currentMonitorId: ''
    }
  },
  created() {
    this.getList()
  },
  methods: {
    async getList() {
      try {
        const res = await this.$http.post('/etp/v1.0/monitor/list', this.queryParams)
        if (res.data.err_code === 0) {
          this.monitorList = res.data.data.monitors
          this.total = res.data.data.total
        }
      } catch (error) {
        console.error(error)
        this.$message.error('获取列表失败')
      }
    },
    handleQuery() {
      this.queryParams.page = 0
      this.getList()
    },
    handleCreate() {
      this.currentMonitorId = ''
      this.dialogVisible = true
    },
    handleEdit(row) {
      this.currentMonitorId = row.id
      this.dialogVisible = true
    },
    async handleDelete(row) {
      try {
        await this.$confirm('确认删除该监控?', '提示', {
          type: 'warning'
        })
        const res = await this.$http.post('/etp/v1.0/monitor/delete', { id: row.id })
        if (res.data.err_code === 0) {
          this.$message.success('删除成功')
          this.getList()
        }
      } catch (error) {
        console.error(error)
        this.$message.error('删除失败')
      }
    },
    handlePageChange(page) {
      this.queryParams.page = page - 1
      this.getList()
    }
  }
}
</script>

<style scoped>
.monitor-list {
  padding: 20px;
}
.filter-container {
  margin-bottom: 20px;
}
</style> 